import { Component} from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { FieldTypePasswordComponent } from '../../../shared/components/field-type-password/field-type-password.component';
import { FormsModule } from '@angular/forms';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  standalone: true,
  imports: [
    AfTranslateDirective, 
    FormsModule, 
    FieldTypePasswordComponent,
    NgClass
  ]
})
export class ResetPasswordComponent {
  resetPassword:any = {
    minimum: 0,
    maximun: 0,
    noSpecialChars: 0,
    validationPass: false,
    equalsPassword: false,
    user: this.context.user,
    newPass: '',
    repeatPass: '',
    newPassword: {
      label: this.translate.instant('reset-password.new-password'),
      required: true,
      errorText: this.translate.instant('reset-password.not-secure-password')
    },
    repeatPassword:{
      label: this.translate.instant('reset-password.repeat-new-password'),
      required: true,
      errorText: this.translate.instant('reset-password.password-no-match')
    },
    passwordInfo: {
      type: 'no-margin',
      fieldTypeId: 'rich',
      label: this.translate.instant('reset-password.info-title'),
      description: this.translate.instant('reset-password.info-description')
    }
  };
  constructor(private translate: AfTranslateFactory,
    private modalService: ModalServiceService,
    private context: ContextFactory,
    private apiService: ApiServiceService,
    private dialogRef: DynamicDialogRef<ResetPasswordComponent>) { }

  itemSelected(type:string, newValue:string){
    this.resetPassword[type] = newValue;
    if(type === 'newPass'){
      this.validateNewPass(newValue);
    }else{
      this.resetPassword.equalsPassword = this.resetPassword.newPass === this.resetPassword.repeatPass;
      this.resetPassword.repeatPassword.error = !this.resetPassword.equalsPassword;
    }
   
  }

  validateNewPass(newValue:string){
    this.resetPassword.minimum = newValue.length >= 8? 2 : 1;
    this.resetPassword.maximun = newValue.length <= 32? 2 : 1;
    this.resetPassword.noSpecialChars = /^[a-zA-Z0-9]+$/.test(newValue)? 2 : 1;
    this.resetPassword.validationPass = this.resetPassword.minimum === 2 && this.resetPassword.maximun === 2 && this.resetPassword.noSpecialChars === 2;
    this.resetPassword.newPassword.error = !this.resetPassword.validationPass;
  }

  savePassword(){
    if(this.resetPassword.validationPass && this.resetPassword.equalsPassword){
      this.resetPassword.changePassword = {
        password: this.resetPassword.oldPass,
        newPassword: this.resetPassword.newPass
      };
      this.apiService.patch('frontusers/changepassword','',this.resetPassword.changePassword)
        .then((data:any)=>{
          this.modalService.successModal({ text: this.translate.instant('change-password.changed-ok') })
            .subscribe((result:any)=>{
              if(result.result === 'ok'){
                this.handleAccept('resetPassword');
              }
            });
        }, (errorData:any)=>{
          this.modalService.errorModal({ text: this.translate.instant('reset-password.error-reset-password') });
        });
    }else{
      this.resetPassword.newPassword.error = !this.resetPassword.validationPass;
      this.resetPassword.repeatPassword.error = !this.resetPassword.equalsPassword;
      this.modalService.errorModal({ text: this.translate.instant('reset-password.error-reset-password-modal') });
    }
  }


  cancel(){
    this.resetPassword.newPass = '';
    this.resetPassword.repeatPass = '';
    this.handleDismiss();
  }

  handleAccept(data: any) {
    this.dialogRef.close({
      result:'ok',
      item: data
    })
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }
}
